export const DEFAULT_LINE_COLORS = [
  "#b4affb",
  "#8f81ff",
  "#66c0f6",
  "#84eeff",
  "#56ebc1",
  "#911eb4",
  "#e6beff",
  "#f553ec",
  "#0a84e3",
  "#e74293",
  "#fc78a8",
  "#a29bfe",
  "#6c5de7",
  "#ff0000",
  "#57cee1",
  "#56ebc1",
  "#FE0000",
  "#354D73",
  "#C35831",
  "#B5B8B1",
  "#C93C20",
  "#DC9D00",
  "#00BB2D",
  "#F54021",
  "#E4A010",
  "#B44C43",
  "#F44611",
  "#308446",
  "#2271B3",
  "#FFFF00",
  "#35682D",
  "#F3A505",
  "#C1876B",
  "#A5A5A5",
  "#E63244",
  "#025669",
  "#B32428"
];
